"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Licence = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Licence = ({ fill = "currentColor", size = 16, name = "Licence" }) => (react_1.default.createElement(Base_1.Base, { fill: fill, title: name, size: size, smooth: true },
    react_1.default.createElement("circle", { r: "3", cx: "8", cy: "7", opacity: ".5" }),
    react_1.default.createElement("path", { d: "M14 7c0-.7-2.1-.9-2.3-1.5-.3-.6 1-2.3.5-2.7-.5-.5-2.1.8-2.7.5C8.9 3.1 8.7 1 8 1s-.9 2.1-1.5 2.3c-.6.3-2.3-1-2.7-.5-.5.4.8 2.1.5 2.7C4.1 6.1 2 6.3 2 7s2.1.9 2.3 1.5c.3.6-1 2.3-.5 2.7.4.4 1.5-.4 2.2-.5V16l2-2 2 2v-5.3c.7.2 1.9.9 2.2.5.5-.5-.8-2.1-.5-2.7.2-.6 2.3-.8 2.3-1.5zm-6 3c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z" })));
exports.Licence = Licence;
//# sourceMappingURL=Licence.js.map